import { render, staticRenderFns } from "./Switchboards.vue?vue&type=template&id=7208f615&scoped=true&"
import script from "./Switchboards.vue?vue&type=script&lang=js&"
export * from "./Switchboards.vue?vue&type=script&lang=js&"
import style0 from "./Switchboards.vue?vue&type=style&index=0&id=7208f615&scoped=true&lang=css&"
import style1 from "./Switchboards.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7208f615",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCol,VRow,VTreeview})
